import { FC } from 'react';
import { InnerIconProps, withIcon } from '@tempusfinance/common-ui';

const SupplyCapLimitComponent: FC<InnerIconProps> = ({ size, color }) => {
  const colorVar = `var(--icon-color, var(${color}))`;

  return (
    <svg
      className="nostra__icon nostra__icon__supplyCapLimit"
      width={size}
      height={size}
      viewBox="0 0 23 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="11.667" cy="11" r="9" stroke={colorVar} strokeWidth="4" />
      <path
        d="M11.667 8.33008V10.9967"
        stroke={colorVar}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.667 13.6633H11.6737"
        stroke={colorVar}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SupplyCapLimit = withIcon(SupplyCapLimitComponent);
